import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import CorporateApi from "Services/Corporate";

//Data
import countryCodeData from "./data/countryCode/index.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SubcmpnyUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

// Max file size
const maxFileSize = 5242880;
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
// File length validator
const fileLengthValidator = (file) => {
  if (file.size > maxFileSize) {
    alert(`File size is larger than ${formatBytes(maxFileSize)}`);
    return {
      code: "file-too-large",
      message: `File size is larger than ${formatBytes(maxFileSize)}`,
    };
  }
  return null;
};

  // Dropzone props
  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];
      //console.log("typeof file-->", typeof(file));

        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImagefile", file);
          formik.setFieldValue("passengerProfileImage", base64String); // Keep the file for form submission
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });

  // Fetch subcompany Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        console.log('res?.data?.data-->',res?.data?.data);
        setDetails(res?.data?.data[0]);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    CorporateApi.getCorporateDetails(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateSubcmpny = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      displayName: formValues?.displayName,
      email: formValues?.email,
      secondaryEmail: formValues?.secondaryEmail,
      password: formValues?.password,
      passConfirmation: formValues?.passConfirmation,
      panNumber:formValues?.panNumber, 
      country: formValues?.country,           
      mobileNumber: formValues?.mobile,
      address: formValues?.address,
      smsMailenable:formValues?.smsMailenable,  
      image: formValues?.passengerProfileImagefile
    };

    //console.log('data--->',data);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Sub-company Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while Update Sub-company",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      CorporateApi.updateCorporate(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue("firstName", details?.firstName);
      formik.setFieldValue("displayName", details?.corporateDetails?.displayName);
      formik.setFieldValue("email", details?.email);      
      formik.setFieldValue("secondaryEmail", details?.corporateDetails?.secondaryEmail);
      formik.setFieldValue("panNumber", details?.corporateDetails?.panNumber);
      formik.setFieldValue("country", details?.country);
      formik.setFieldValue("mobile", details?.mobileNumber);   
      formik.setFieldValue("address", details?.address);
      formik.setFieldValue("smsMailenable", details?.corporateDetails?.smsMailenable);     
      formik.setFieldValue("passengerProfileImage", details?.image);
      formik.setFieldValue("passengerProfileImagefile", details?.image);
    }
  }
    updateFormValues();
  }, [details]);

  // Formik

  const formik = useFormik({
    initialValues: {
      firstName: "",
      displayName: "",
      email: "",
      secondaryEmail:"",
      panNumber: "",
      country: "",
      mobile: "",
      address: "",
      smsMailenable: false,
      passengerProfileImage:"",
    },
    validationSchema: yup.object({
      firstName: yup.string().required("First Name is required").nullable(),
      displayName: yup.string().required("display Name is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      secondaryEmail: yup
        .string()
        .email("Invalid email format")
        .required("Secondary Email is required")
        .nullable(),        
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
      panNumber: yup.string().required("Pan Number is required").nullable(),
      country: yup.string().required("Country is required").nullable(),
      address: yup.string().required("address is required").nullable(),
      smsMailenable: yup
            .boolean()
            .required("Choose enable or disable is required")
            .nullable(),    
      passengerProfileImage: yup.string().required("Corporate Logo is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateSubcmpny,
  });

  const countryCodes = Object.keys(countryCodeData);

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Corporate
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={formik?.values?.passengerProfileImage ?
                        formik?.values?.passengerProfileImage:
                        "/assets/images/user/avatar.png"
                      }
                      alt="avatar"
                      className={classes.img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>

           <Grid container>
             <section className={classes.container}>
               <Grid item xs={12} className={classes.detailsContainer}>
 
                 <Grid container className={classes.containerWrapper}>
                {/* section right */} 
                   <Grid item xs={12} md={6} lg={6} xl={6}>
                     <Grid container>
 
                       <Grid item xs={12} md={12} lg={12}>
                         <Grid container>
                         <Grid
                             item
                             md={6}
                             lg={6}
                             xl={6}
                             className={classes.textFieldWrapper}
                           >
                         <TextField
                           inputProps={{
                           form: {
                                 autocomplete: 'off',
                               },
                           }}
                           id="firstName"
                           name="firstName"
                           label="Legal Name"
                           value={formik?.values?.firstName}
                           defaultValue={formik?.values?.firstName}
                           onChange={formik.handleChange}
                           error={
                             formik?.errors?.firstName &&
                             formik?.touched?.firstName
                           }
                           helperText={
                             formik?.errors?.firstName &&
                             formik?.touched?.firstName &&
                             formik?.errors?.firstName
                           }
                           fullWidth
                           variant="outlined"
                           size="small"
                         ></TextField>
                           </Grid>  
                           <Grid
                             item
                             md={6}
                             lg={6}
                             xl={6}
                             className={classes.textFieldWrapper}
                           >
                         <TextField
                           inputProps={{
                           form: {
                                 autocomplete: 'off',
                               },
                           }}
                           name="displayName"
                           id="displayName"
                           label="Display Name"
                           value={formik?.values?.displayName}
                           defaultValue={formik?.values?.displayName}
                           onChange={formik?.handleChange}
                           error={
                             formik?.errors?.displayName &&
                             formik?.touched?.displayName
                           }
                           helperText={
                             formik?.errors?.displayName &&
                             formik?.touched?.displayName &&
                             formik?.errors?.displayName
                           }
                           fullWidth
                           variant="outlined"
                           size="small"
                         ></TextField>
                         </Grid>
                        </Grid>
                       </Grid>
 
                       <Grid item md={12} lg={12} xl={12}>
                         <Grid container>
                           <Grid
                             item
                             md={12}
                             lg={12}
                             xl={12}
                             className={classes.textFieldWrapper}
                           >
                             <TextField
                               inputProps={{
                               form: {
                                     autocomplete: 'off',
                                   },
                               }}
                               name="mobile"
                               id="mobile"
                               label="Mobile Number"
                               value={formik?.values?.mobile}
                               defaultValue={formik?.values?.mobile}
                               onChange={formik?.handleChange}
                               error={
                                 formik?.errors?.mobile &&
                                 formik?.touched?.mobile
                               }
                               helperText={
                                 formik?.errors?.mobile &&
                                 formik?.touched?.mobile &&
                                 formik?.errors?.mobile
                               }
                               fullWidth
                               variant="outlined"
                               size="small"
                             ></TextField>
                           </Grid>
                         </Grid>
                       </Grid>
 
                       <Grid
                         item
                         xs={12}
                         md={12}
                         lg={12}
                         xl={12}
                         className={classes.textFieldWrapper}
                       >
                         <TextField
                           inputProps={{
                           form: {
                                 autocomplete: 'off',
                               },
                           }}
                           name="email"
                           id="email"
                           label="Email"
                           value={formik?.values?.email}
                           onChange={formik?.handleChange}
                           error={
                             formik?.errors?.email && formik?.touched?.email
                           }
                           helperText={
                             formik?.errors?.email &&
                             formik?.touched?.email &&
                             formik?.errors?.email
                           }
                           fullWidth
                           variant="outlined"
                           size="small"
                         />
                       </Grid>
 
                     <Grid
                     item
                     xs={12}
                     md={12}
                     lg={12}
                     xl={12}
                     className={classes.textFieldWrapper}
                     >
                     <TextField
                     inputProps={{
                     form: {
                     autocomplete: 'off',
                     },
                     }}
                     name="secondaryEmail"
                     id="secondaryEmail"
                     label="Secondary Email"
                     value={formik?.values?.secondaryEmail}
                     onChange={formik?.handleChange}
                     error={
                     formik?.errors?.secondaryEmail && formik?.touched?.secondaryEmail
                     }
                     helperText={
                     formik?.errors?.secondaryEmail &&
                     formik?.touched?.secondaryEmail &&
                     formik?.errors?.secondaryEmail
                     }
                     fullWidth
                     variant="outlined"
                     size="small"
                     />
                     </Grid>
 
                   <Grid
                   item
                   xs={12}
                   md={12}
                   lg={12}
                   xl={12}
                   className={classes.textFieldWrapper}
                   >
                   <TextField
                   inputProps={{
                   form: {
                   autocomplete: 'off',
                   },
                   }}
                   name="panNumber"
                   id="panNumber"
                   label="Pan Number"
                   value={formik?.values?.panNumber}
                   onChange={formik?.handleChange}
                   error={
                   formik?.errors?.panNumber && formik?.touched?.panNumber
                   }
                   helperText={
                   formik?.errors?.panNumber &&
                   formik?.touched?.panNumber &&
                   formik?.errors?.panNumber
                   }
                   fullWidth
                   variant="outlined"
                   size="small"
                   />
                   </Grid>
 
                     </Grid>
                   </Grid>
                {/* section left */} 
                   <Grid item xs={12} md={6} lg={6} xl={6}>
 
                   <Grid
                   item
                   xs={12}
                   md={12}
                   lg={12}
                   xl={12}
                   className={classes.textFieldWrapper}
                   >
                   <TextField
                   inputProps={{
                   form: {
                   autocomplete: 'off',
                   },
                   }}
                   name="address"
                   id="address"
                   label="Address"
                   value={formik?.values?.address}
                   onChange={formik?.handleChange}
                   error={
                   formik?.errors?.address && formik?.touched?.address
                   }
                   helperText={
                   formik?.errors?.address &&
                   formik?.touched?.address &&
                   formik?.errors?.address
                   }
                   fullWidth
                   variant="outlined"
                   size="small"
                   />
                   </Grid> 
 
                       <Grid
                         item
                         xs={12}
                         md={12}
                         lg={12}
                         xl={12}
                         className={classes.textFieldWrapper}
                       >
                         <TextField
                           inputProps={{
                           form: {
                                 autocomplete: 'off',
                               },
                           }}
                           name="country"
                           id="country"
                           select
                           label="Country"
                           value={formik?.values?.country || ""}
                           onChange={formik?.handleChange}
                           error={
                             formik?.errors?.country && formik?.touched?.country
                           }
                           helperText={
                             formik?.errors?.country &&
                             formik?.touched?.country &&
                             formik?.errors?.country
                           }
                           fullWidth
                           variant="outlined"
                           size="small"
                         >
                           {countryCodeData.map((country) => (
                                 <MenuItem
                                   key={country.code}
                                   value={country.name}
                                 >
                                   {`${country.code} (${country.name})`}
                                 </MenuItem>
                               ))}
                         </TextField>
                       </Grid>
 
 
                       <Grid
                         item
                         xs={12}
                         md={12}
                         lg={12}
                         xl={12}
                         className={classes.textFieldWrapper}
                       >
                         <TextField
                           inputProps={{
                           form: {
                                 autocomplete: 'off',
                               },
                           }}
                           name="smsMailenable"
                           id="smsMailenable"
                           select
                           label="SMS/Mail for Customers"
                           value={formik?.values?.smsMailenable || ""}
                           onChange={formik?.handleChange}
                           error={
                             Boolean(formik?.errors?.smsMailenable) && formik?.touched?.smsMailenable
                           }
                           helperText={
                             formik?.errors?.smsMailenable &&
                             formik?.touched?.smsMailenable &&
                             formik?.errors?.smsMailenable
                           }
                           fullWidth
                           variant="outlined"
                           size="small"
                         >
                      
                             <MenuItem key={true} value={true} >
                              Enabled
                             </MenuItem>
       
                             <MenuItem key={false} value={false} >
                              Disabled
                             </MenuItem>
       
                         </TextField>
                       </Grid>
 
                   </Grid>
                 </Grid>
 
               {/* button section */}
 
                 <Grid container>
                   <Grid
                     item
                     xs={12}
                     md={12}
                     lg={12}
                     xl={12}
                     className={classes.sbtBtnWrapper}
                   >
                     <Button variant="contained" onClick={formik?.handleSubmit}>
                     Update Corporate
                     </Button>
                   </Grid>
                 </Grid>
               </Grid>
             </section>
           </Grid>

        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubcmpnyUpdate;
